<template>
  <form @submit.prevent="submit">
    <div class="u-scroller u-space--h u-space--large">
      <label
        v-for="journey in journeys"
        :key="journey.id"
        :class="{
          journey: true,
          'journey--checked': journey.picked,
          [`journey--${journey.status}`]: true
        }"
      >
        <input type="checkbox" :value="journey.id" v-model="journey.picked" />
        <h3>{{ journey.from }} to {{ journey.to }}</h3>

        <footer class="u-split">
          <template>
            <select v-model="journey.status" @change="updateStatus(journey)">
              <option value="in-progress">In Progress</option>
              <option value="completed">Completed</option>
              <option value="forfeited">Forfeited</option>
            </select>
          </template>
          <h4 class="journey__score">{{ journey.score }}</h4>
        </footer>
      </label>
    </div>

    <input
      type="submit"
      class="button"
      :disabled="!pickedJourneys.length"
      value="Pick"
    />
  </form>
</template>

<script>
export default {
  data() {
    return {
      journeys: this.$store.getters.ponderingJourneys.map(x => ({
        status: "in-progress",
        picked: false,
        ...x
      }))
    };
  },

  computed: {
    pickedJourneys() {
      return this.journeys
        .filter(x => x.picked)
        .map(x => ({ id: x.id, status: x.status }));
    }
  },

  methods: {
    updateStatus(journey) {
      if (journey.status !== "in-progress") {
        journey.picked = true;
      }
    },

    submit() {
      this.$store.commit("pickJourneys", this.pickedJourneys);
      this.$store.commit("setStatus", "finishing");
      this.$store.dispatch("nextGo");
    }
  }
};
</script>
